import { Author } from '../author';

/**
 * Model definition for ContentAuthor
 */
export interface ContentAuthor {
  __component: 'content.author';
  id: string;
  reference?: Author;
  ssr: boolean;
}

export function isContentAuthor(obj: { __component?: string }): obj is ContentAuthor {
  return obj.__component === 'content.author';
}
